declare global {
    interface Window {
        env: any
    }
}

// change with your own variables
type EnvType = {
    PUBLIC_URL: string,
    REACT_APP_TYPE: string,
    REACT_APP_API_URL: string,
    REACT_APP_API_KEY: string,
    REACT_APP_COMPANY_NAME: string,
    REACT_APP_COMPANY_REGISTERED: string,
    REACT_APP_OG_TITLE: string,
    REACT_APP_LINK_FACEBOOK: string,
    REACT_APP_LINK_INSTAGRAM: string,
    REACT_APP_LINK_YOUTUBE: string,
    REACT_APP_SITE_NAME: string,
    REACT_APP_OG_URL: string,
    REACT_APP_EXTERNAL_LOGIN_PREFIX: string,
    REACT_APP_GOOGLE_TAG_ID: string,
    NODE_ENV: string
}

export const env: EnvType = { ...process.env, ...window.env }

export const isDevEnvironment = (): boolean => {
    return env.NODE_ENV === 'development';
}